import { SNAKE_SPEEDS, type SnakeSpeed } from "@bing/shared";
import type { SnakeLook } from "./draw";

/**
 * «مار» — the speed and the look, remembered on the device (operator, 2026-11-02). Both are the
 * player's own choice and stay on this device; nothing about them reaches the server (the score
 * does — through `best.ts`).
 *
 * They live here, not in `settings/prefs.ts`: that module's guard
 * (`apps/web/test/settings-prefs.test.ts`) keeps the removed «سرعت بازی» setting from coming back,
 * and exports no speed pref. The storage keys are the ones these prefs were first saved under, so a
 * choice made before the move is still read. Storage is guarded as everywhere in the prefs (private
 * mode, non-browser envs).
 */

const SNAKE_SPEED_KEY = "bing:snakeSpeed";
const SNAKE_LOOK_KEY = "bing:snakeLook";

/** «مار»'s speed — معمولی until the player picks another. */
export const DEFAULT_SNAKE_SPEED: SnakeSpeed = "normal";
/** «مار»'s look — «امروزی» (our games' look) until the player picks «نوستالژی». */
export const DEFAULT_SNAKE_LOOK: SnakeLook = "modern";

function readSnakeSpeed(): SnakeSpeed {
  try {
    const raw = localStorage.getItem(SNAKE_SPEED_KEY);
    return raw !== null && (Object.keys(SNAKE_SPEEDS) as string[]).includes(raw)
      ? (raw as SnakeSpeed)
      : DEFAULT_SNAKE_SPEED;
  } catch {
    return DEFAULT_SNAKE_SPEED;
  }
}
let snakeSpeed = readSnakeSpeed();

function readSnakeLook(): SnakeLook {
  try {
    const raw = localStorage.getItem(SNAKE_LOOK_KEY);
    return raw === "modern" || raw === "retro" ? raw : DEFAULT_SNAKE_LOOK;
  } catch {
    return DEFAULT_SNAKE_LOOK;
  }
}
let snakeLook = readSnakeLook();

export function getSnakeSpeed(): SnakeSpeed {
  return snakeSpeed;
}

export function setSnakeSpeed(value: SnakeSpeed): void {
  snakeSpeed = value;
  try {
    localStorage.setItem(SNAKE_SPEED_KEY, value);
  } catch {
    // ignore storage failures
  }
}

export function getSnakeLook(): SnakeLook {
  return snakeLook;
}

export function setSnakeLook(value: SnakeLook): void {
  snakeLook = value;
  try {
    localStorage.setItem(SNAKE_LOOK_KEY, value);
  } catch {
    // ignore storage failures
  }
}
